import cn from 'classnames';
import type React from 'react';

import * as st from './styles.module.scss';

type Props = {
	title: string;
	hideBackground?: boolean;
	children: React.ReactNode;
};

export const Row: React.FC<Props> = ({ title, hideBackground, children }) => {
	return (
		<div className={st.row}>
			<div className={st.row__label}>{title}</div>
			<div className={cn(st.row__value, hideBackground && st.hide)}>{children}</div>
		</div>
	);
};
